import { EmployeeEntity } from '../entities';
import { UpdateEmployeeBaseIdPayload } from '../ports/payloads';
import { EmployeeRepository } from '../ports/repositories';

export class UpdateEmployeeBaseIdUsecase {
  constructor(private readonly repo: EmployeeRepository) {}

  run(payload: UpdateEmployeeBaseIdPayload): Promise<EmployeeEntity> {
    return this.repo.updateBaseId(payload);
  }
}
